import { render } from "./SelectLocation.vue?vue&type=template&id=465d3aaf&scoped=true"
import script from "./SelectLocation.vue?vue&type=script&lang=js"
export * from "./SelectLocation.vue?vue&type=script&lang=js"

import "./SelectLocation.vue?vue&type=style&index=0&id=465d3aaf&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465d3aaf"]])

export default __exports__